<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import {watch} from "vue";
import {useBankStore} from "@/stores/Bank";

export default {
    setup() {
        const {
            total,
            loading,
            filter,
        } = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {$i18n, $router} = useTools();

        const bankStore = useBankStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
                width: "0%"
            },
            {
                text: $i18n.t("common.name"),
                align: "start",
                sortable: true,
                value: "name",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'banks.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'banks.delete', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("bank.xlsxmapper"),
                icon: 'mdi-microsoft-excel',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'banks.xlsxmapper', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("bank.uploadmodel"),
                icon: 'mdi-microsoft-excel',
                color: 'teal',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'banks.uploadmodel', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/banks', {params: transformFilterValues(filter.value)}).then((response) => {
                bankStore.setBanks(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "banks.view", params: {id: item.id}});
        }


        watch(filter, () => {
            findAll();
        }, {deep: true, immediate: true});

        return {
            bankStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            findAll,
            view
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.bank')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    @press="$router.push({ name: 'banks.add' })"
                />
            </template>
            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="bankStore.banks"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:item.code="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:item.name="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:item.virementModel="{ item }">
                        <v-icon v-if="item.virementModel" color="blue darken-2">
                            mdi-paperclip
                        </v-icon>
                    </template>

                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>